<template>
	<div class="row">
		<div class="col-md-6 px-4">
			<div class="row align-items-center justify-content-start mb-3">
				<div class="col-md-12">
					<div class="row align-items-center justify-content-start mb-3">
						<div class="col-md-10">
							<strong>Password Reset Link</strong>
						</div>
						<div class="col-md-2">
							<div class="mb-8">
								<form @submit.prevent="sendResetLinkToEmail">
									<button type="submit" class="btn btn-primary">SEND</button>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row align-items-center justify-content-start mb-3">
				<div class="col-md-12">
					<div class="row align-items-center justify-content-start mb-3">
						<div class="col-md-6">
							<strong>Password</strong>
						</div>
						<div class="col-md-6">
							<div class="custom-control custom-switch">
								<input
									type="checkbox"
									v-model="changePasswordFeauture"
									class="custom-control-input"
									id="customSwitches"
								/>

								<label class="custom-control-label" for="customSwitches"
									>Do you want to change the password?
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="changePasswordFeauture == true" class="col-md-12">
				<div class="row align-items-center justify-content-start mb-3">
					<div class="col-md-12 px-0">
						<form @submit.prevent="checkPasswordMatch">
							<strong>Reset Password</strong>
							<Br></Br>
							<Br></Br>
							<div
								class="form-group form-group row align-items-center justify-content-start mb-3"
							>
								<label class="col-md-3">New Password</label>
								<div class="col-md-9">
									<input
										type="password"
										v-model="password"
										class="form-control"
									/>
									<p v-if="passwordStrength === 'weak'" class="text-danger">
										Weak password
									</p>
									<p v-if="passwordStrength === 'medium'" class="text-warning">
										Medium password
									</p>
									<p v-if="passwordStrength === 'strong'" class="text-success">
										Strong password
									</p>
									<span class="invalid-feedback" style="display: none"> </span>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-md-3">Confirm Password</label>
								<div class="col-md-9">
									<input
										type="password"
										v-model="confirmPassword"
										class="form-control"
									/>
									<span class="invalid-feedback" style="display: none"> </span>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-12 text-right">
									<button type="submit" class="btn btn-primary">
										<i class="fa fa-btn fa-refresh"></i>
										Reset Password
									</button>
								</div>
							</div>
							<p v-if="errorMessage">{{ errorMessage }}</p>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import AdministrationMixin from '../AdministrationMixin';
import zxcvbn from 'zxcvbn';

export default {
	props: {
		teams: Array,
		user: {
			Object,
			required: true,
		},
	},
	mixins: [AdministrationMixin],

	data() {
		return {
			password: '',
			email: '',
			confirmPassword: '',
			errorMessage: '',
			passwordStrength: '',
			changePasswordFeauture: false,
			verified: false,
		};
	},
	watch: {
		password(newValue, oldValue) {
			const result = zxcvbn(newValue);
			switch (true) {
				case result.score < 3:
					this.passwordStrength = 'weak';
					break;
				case result.score < 4:
					this.passwordStrength = 'medium';
					break;
				default:
					this.passwordStrength = 'strong';
			}
		},
	},
	methods: {
		async changePassword() {
			const url = `${this.usersUrl}/${this.user.id}/change-password`;
			const postData = {
				password: this.password,
			};
			await axios.post(url, postData);
			swal('Good job!', 'Password updated successfully', 'success');
			return url;
		},
		checkPasswordMatch() {
			if (this.password !== this.confirmPassword) {
				this.errorMessage = swal('Error', 'Passwords do not match', 'error');
			} else {
				this.changePassword();
			}
		},
		async sendResetLinkToEmail() {
			const url = `${this.usersUrl}/${this.user.id}/password/email`;
			const postData = {
				email: this.user.email,
				verified: this.user.verified,
			};
			try {
				await axios.post(url, postData);
				swal('Good job!', 'Password reset link sent successfully', 'success');
			} catch (e) {
				swal('Error', `Could not send password reset email to user\n${e}`, 'error');
			}
			return url;
		},
	},
	mounted() {},
};
</script>
<style>
p {
	margin: 0;
	padding-top: 5px;
	padding-left: 5px;
}
</style>
